import { DefaultApi } from '../../../api';
import { getCatchError } from '../../../getCatchError';
import { urls } from '../../../urls';

const setGetFreespin = (params, setCode) => {
    return async (dispatch, getState) => {
        try {
            const { data } = DefaultApi({
                params,
                method: 'get',
                url: urls.GET_FREESPIN
            });

            if (data.status === 'success') {
                setCode(JSON.stringify(data.data))
            }

        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetFreespin as SetGetFreespin
}